import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from './core/services/local-storage/local-storage.service';
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { EventMessage, EventType } from '@azure/msal-browser';
import { filter } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './core/services/auth/auth.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
    notifications: Array<string> = [];
    title = 'gyan-4-ui';
    constructor(
        private translateService: TranslateService,
        private msalBroadcastService: MsalBroadcastService,
        private localStorageService: LocalStorageService,
        private authService: AuthService,
        @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
        private msalService: MsalService,
    ) {
        const userLang = navigator.language || 'en';
        const lanuageCode = userLang.split('-')[0];
        this.translateService.setDefaultLang(lanuageCode);
        this.translateService.use(lanuageCode);
    }
    isLoading: boolean = false;
    ngOnInit(): void {
        this.msalService.instance.enableAccountStorageEvents();
        console.log('notification >>> ');
        this.localStorageService.removeItem('gyanData');
        this.localStorageService.removeItem('articleClickIndex');
        this.initAzureMethod();
        this.callLogoutFromAnotherTab();
    }
    @HostListener('document:mousemove', ['$event'])
    @HostListener('document:keypress', ['$event'])
    onActivity() {
        this.authService.resetAutoLogout();
    }
    initAzureMethod() {
        this.msalBroadcastService.msalSubject$
            .pipe(
                filter(
                    (msg: EventMessage) =>
                        msg.eventType === EventType.LOGIN_SUCCESS || msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS || msg.eventType === EventType.SSO_SILENT_SUCCESS,
                ),
            )
            .subscribe((result: EventMessage) => {
                this.setLoginSession();
            });
    }
    setLoginSession() {
        //   alert('setLoginSession');
        this.isLoading = true;
        this.authService.setCookie('g-ap-guest', 'false', 30000, environment.cookieDomain);
        this.authService.setTokenId();
        this.authService.getSsoResponse().subscribe(
            (response: any) => {
                //     alert('setLoginSession');
                this.authService.clearTimerTimeout();
                this.authService.startAutoLogout();
                this.authService.setCookie('g-ap-p-id', response.personId.toString(), 30000, environment.cookieDomain);
                // this.authService.setCookie('g-ap-gapi-c', response.gyanCookie.toString(), 30000, environment.cookieDomain);
                this.authService.setCookie('g-ap-g-tkn', response.gyanLoginToken.toString(), 30000, environment.cookieDomain);
                this.authService.setCookie('g-ap-u-id', response.userId.toString(), 30000, environment.cookieDomain);
                this.authService.setCookie('g-ap-p-fn', response.firstName.toString(), 30000, environment.cookieDomain);
                this.authService.setCookie('g-ap-p-ln', response.lastName.toString(), 30000, environment.cookieDomain);
                this.authService.setCookie('g-ap-p-eid', response.email.toString(), 30000, environment.cookieDomain);

                this.authService.setCookie('g-ap-p-iv', response.isVerified.toString(), 30000, environment.cookieDomain);
                this.authService.callGyanAuth();
                this.authService.setCallPreviousSearchGyan();
                this.isLoading = false;
            },
            (error: HttpErrorResponse) => {
                console.log('error');
                console.log(error);
                this.isLoading = false;
            },
        );
    }

    callLogoutFromAnotherTab() {
        window.addEventListener('storage', (event) => {
            if (event.key === 'msalLogoutEvent') {
                this.msalService.logout();
            }
        });
    }
}
